<template>
	<div class="content">
		<div class="section">
			<div class="col-2">
				<div class="search-top">
					<div class="left">
						<div class="line">
							<label class="input-label">검색키워드</label>
							<input
								class="form-control"
								type="text"
								placeholder="물건명, 주소, 소유자, 전소유자, 전화번호"
								maxlength="80"
								v-model="searchOptions_.keyword"
								@keyup.enter="btnSearch"
							/>
						</div>
						<div class="line">
							<label class="input-label">매물상태</label>
							<label class="input-checkbox">
								<input type="checkbox" v-model="searchOptions_.st" @change="btnStOption" />
								<span class="checkbox"></span>
								<span class="text">전체</span>
							</label>
							<label class="input-checkbox">
								<input type="checkbox" v-model="searchOptions_.st_" :value="'ready'" />
								<span class="checkbox"></span>
								<span class="text">준비</span>
							</label>
							<label class="input-checkbox">
								<input type="checkbox" v-model="searchOptions_.st_" :value="'done'" />
								<span class="checkbox"></span>
								<span class="text">매물</span>
							</label>
							<label class="input-checkbox">
								<input type="checkbox" v-model="searchOptions_.st_" :value="'hold'" />
								<span class="checkbox"></span>
								<span class="text">보류</span>
							</label>
							<label class="input-checkbox">
								<input type="checkbox" v-model="searchOptions_.st_" :value="'sell'" />
								<span class="checkbox"></span>
								<span class="text">매각</span>
							</label>
							<label class="input-checkbox" title="매물등록일자 기준 최근 1년 이내만 표시">
								<input type="checkbox" v-model="recentOneYearOnly" @change="onToggleRecentYear" />
								<span class="checkbox"></span>
								<span class="text">최근 1년 등록만</span>
							</label>
						</div>
					</div>
					<div class="right">
						<button type="button" class="btn search" @click="btnSearch"><b-icon-search /></button>
						<button type="button" class="btn list" @click="isDetailSearchPopupShow = true">
							<b-icon-funnel-fill />
						</button>
					</div>
				</div>
				<div class="section">
					<div class="section-tit">열람목록</div>
					<div class="table-wrap">
						<table class="table click">
							<colgroup>
								<col width="10%" />
								<col width="10%" />
								<col width="20%" />
								<col width="50%" />
								<col width="10%" />
							</colgroup>
							<tr class="sticky">
								<th>상태</th>
								<th>물건번호</th>
								<th>물건명</th>
								<th>주소</th>
								<th>삭제</th>
							</tr>
							<tr
								v-for="(c, idx) in countList"
								:key="'count_' + c.building_view_log_uid"
								@click="btnOnDetail(c.building_uid, idx, 'count')"
							>
								<td>{{ $ITEM_STATE[c.sell_status] }}</td>
								<td>{{ c.building_uid }}</td>
								<td>{{ c.building_name }}</td>
								<td>{{ c.jibun_addr }}<br />{{ c.road_addr }}</td>
								<td>
									<button type="button" class="btn" @click.stop="btnDelCount(c.building_view_log_uid)">
										<b-icon-trash />
									</button>
								</td>
							</tr>
						</table>
					</div>
				</div>
			</div>
		</div>
		<div class="section">
			<div class="section-tit">
				물건목록
				<span class="sub">검색결과 : {{ totalCount }}건</span>
				<div class="right">
					<button type="button" class="btn btn-xxsm btn-secondary" v-if="!$store.getters.getPartnerGuest" @click="callSMS">SMS</button>&nbsp;
					<button type="button" class="btn btn-xxsm btn-secondary" v-if="$store.getters.getPartnerGuest" @click="btnAddCart">물건담기</button>&nbsp;
					<button type="button" class="btn btn-xxsm btn-secondary" @click="btnOnBriefing">고객탭연결</button>&nbsp;
					<!-- Weekly 는 사용 권한이 있는 직원에게만 보인다(DE: 기본은 팀장과 관리자). 판정은 서버의 게이트·권한을
					     따르는 getWeeklyBlocked 한 곳 — 헤더 메뉴·라우터 가드·백엔드도 같은 기준. -->
					<!-- 새로 만들지, 이미 있는 Weekly 에 더할지는 넘어간 화면(ReportAdmin)에서 고른다. -->
					<button type="button" class="btn btn-xxsm btn-primary" v-if="!$store.getters.getWeeklyBlocked" @click="btnOnWeekly">Weekly 담기</button>
				</div>
			</div>
			<div class="table-wrap">
				<table class="table sm click">
					<colgroup>
						<col width="2%" />
						<col width="3%" />
						<col width="5%" />
						<col width="10%" />
						<col width="20%" />
						<col width="10%" />
						<col width="5%" />
						<col width="5%" />
						<col width="5%" />
						<col width="5%" />
						<col width="5%" />
						<col width="5%" />
						<col width="15%" />
						<col width="5%" />
					</colgroup>
					<tr>
						<th>
							<label class="input-checkbox">
								<input type="checkbox" v-model="brifSt" @change="btnOnAddBrif" />
								<span class="checkbox"></span>
							</label>
						</th>
						<th>상태</th>
						<th>물건번호</th>
						<th>물건명</th>
						<th>주소</th>
						<th>용도지역</th>
						<th>대지(평)</th>
						<th>연면적(평)</th>
						<th>매매가(만)</th>
						<th>보증금</th>
						<th>월임대료</th>
						<th>연수익률</th>
						<th>주변역</th>
						<th>도로사항</th>
						<th>지도보기</th>
					</tr>
					<tr
						v-for="(item, idx) in itemList"
						:key="'total_' + item.building_uid"
						@click="btnOnDetail(item.building_uid, idx, 'total')"
					>
						<td @click.stop>
							<label class="input-checkbox">
								<input type="checkbox" v-model="item.brifSt" />
								<span class="checkbox"></span>
							</label>
						</td>
						<td>
							<span
								v-bind:class="{
									'txt-c--blue': item.sell_status == 'done',
									'txt-c--grey': item.sell_status == 'ready',
									'txt-c--red': item.sell_status == 'sell',
								}"
							>
								{{ $ITEM_STATE[item.sell_status] }}
							</span>
						</td>
						<td>{{ item.building_uid }}</td>
						<td>{{ item.building_name }}</td>
						<td>{{ item.jibun_addr }}<br />{{ item.road_addr }}</td>
						<td>{{ item.cfg_val1 }}</td>
						<td>{{ $formatArea(item.land_size_p) }}</td>
						<td>{{ $formatArea(item.total_size_p) }}</td>

						<td>{{ $formatMoney(item.sell_price, $MONEY_FORMAT_TYPE.LOAN) }}</td>
						<td>{{ $formatMoney(item.ex_sum_rent_deposit, $MONEY_FORMAT_TYPE.LOAN) }}</td>
						<td>{{ $formatMoney(item.ex_sum_rent_money, $MONEY_FORMAT_TYPE.LOAN) }}</td>
						<td>{{ item.total_income_rate }}</td>
						<td>{{ item.substation }}</td>
						<td>
							<template v-if="item.roadwide_1">{{ item.roadwide_1 }}m </template>
							<template v-if="item.roadwide_2">, {{ item.roadwide_2 }}m </template>
							<template v-if="item.roadwide_3">, {{ item.roadwide_3 }}m </template>
							<template v-if="item.roadwide_4">, {{ item.roadwide_4 }}m </template>
						</td>
						<td>
							<button type="button" class="btn map1" @click.stop="$openNaverMap(item.jibun_addr)"></button>
							<button type="button" class="btn map2" @click.stop="$openDaumMap(item.jibun_addr)"></button>
						</td>
					</tr>
				</table>
			</div>
			<ul class="pagination b-pagination pagination-sm" v-if="pageData != null && pageData.list.length">
				<li class="page-item" v-bind:class="{ disabled: 1 == page }">
					<button type="button" class="page-link" @click="getItemList(1)">
						<b-icon-chevron-double-left />
					</button>
				</li>

				<li class="page-item" v-bind:class="{ disabled: pageData.first == null }">
					<button type="button" class="page-link" @click="pageData.first !== null ? getItemList(pageData.first) : ''">
						<b-icon-chevron-left />
					</button>
				</li>
				<li
					v-for="pg in pageData.list"
					v-bind:key="'pg_' + pg"
					class="page-item"
					v-bind:class="{ active: pageData.currentPage == pg }"
				>
					<button type="button" class="page-link" @click="getItemList(pg)">{{ pg }}</button>
				</li>
				<li class="page-item" v-bind:class="{ disabled: pageData.end == null }">
					<button type="button" class="page-link" @click="pageData.end !== null ? getItemList(pageData.end) : ''">
						<b-icon-chevron-right />
					</button>
				</li>

				<li class="page-item" v-bind:class="{ disabled: pageData.totalPage == page }">
					<button type="button" class="page-link" @click="getItemList(pageData.totalPage)">
						<b-icon-chevron-double-right />
					</button>
				</li>
			</ul>
		</div>
	</div>

	<!-- 상세검색 팝업은 매수고객 카드(UserDetail)와 같이 쓴다(CS). 조건 조립은 utils/sellSearch.mjs. -->
	<SellDetailSearchPopup
		v-if="isDetailSearchPopupShow"
		:options="searchOptions_"
		@search="onDetailSearch"
		@clear="clearSearch"
		@close="onDetailClose"
	/>

	<!-- <div v-if="isDetailPopupShow" class="popup-wrap">
		<div class="dim"></div>
		<div class="popup full">
			<div class="popup-tit">
				상세
				<button type="button" class="btn btn-close" @click="isDetailPopupShow = false"><b-icon-x-lg /></button>
			</div>
			<div class="popup-con">
				<MapDetail @get_count="getCountList" :bid="this.isDetailPopupShow" />
			</div>
		</div>
	</div> -->
</template>

<script>
// import MapDetail from '@/views/MapDetail.vue';
import SellDetailSearchPopup from '@/components/SellDetailSearchPopup.vue';
import {
	defaultSellSearchOptions,
	normalizeSellSearch,
	recentYearWindow,
	sellSearchParams,
	SELL_STATUS_ALL,
} from '@/utils/sellSearch.mjs';
export default {
	name: 'TotalSearch',
	components: { SellDetailSearchPopup },
	data() {
		return {
			itemList: [],
			isDetailSearchPopupShow: false,
			isDetailPopupShow: false,

			page: 1,
			pageData: null,
			totalCount: null,
			itemSize: 20,
			blockSize: 5,

			// '최근 1년 등록만' 토글 기본 ON — 매물등록일자(done_date_time) 기준 최근 365일만 노출.
			recentOneYearOnly: true,
			searchOptions: { ...defaultSellSearchOptions(), userId2: '' },
			searchOptions_: defaultSellSearchOptions(),
			countList: [],

			brifSt: false,
			brifList: [],

			moreInfo: {
				mode: null,
				s: null,
				e: null,
				userId: null,
			},
		};
	},
	created() {
		if (Object.prototype.hasOwnProperty.call(this.$route.query, 'mode')) {
			this.moreInfo.mode = this.$route.query.mode;
		}

		if (Object.prototype.hasOwnProperty.call(this.$route.query, 'userId')) {
			this.moreInfo.userId = this.$route.query.userId;

			if (this.moreInfo.mode == 'done' || this.moreInfo.mode == 'week') {
				this.searchOptions.memUid = this.$route.query.userId;
				this.searchOptions_.memUid = this.$route.query.userId;
			} else {
				this.searchOptions.userId = this.$route.query.userId;
				this.searchOptions_.userId = this.$route.query.userId;
			}
		}

		if (
			Object.prototype.hasOwnProperty.call(this.$route.query, 's') &&
			Object.prototype.hasOwnProperty.call(this.$route.query, 'e')
		) {
			this.moreInfo.s = this.$route.query.s;
			this.moreInfo.e = this.$route.query.e;

			this.searchOptions.regDate_S = this.moreInfo.s;
			this.searchOptions_.regDate_S = this.moreInfo.s;
			this.searchOptions.regDate_E = this.moreInfo.e;
			this.searchOptions_.regDate_E = this.moreInfo.e;
		}

		if (this.moreInfo.mode == 'all') {
			this.searchOptions.st_ = SELL_STATUS_ALL.slice();
			this.searchOptions_.st_ = SELL_STATUS_ALL.slice();
		} else if (this.moreInfo.mode == 'done') {
			this.searchOptions.st_ = ['done'];
			this.searchOptions_.st_ = ['done'];
		} else if (this.moreInfo.mode == 'week') {
			this.searchOptions.st_ = ['done'];
			this.searchOptions_.st_ = ['done'];
		}

		// 토글 기본 ON: URL(s/e)로 매물등록일자 범위가 들어오면(대시보드 드릴다운 등) 그 범위 우선·토글 OFF.
		if (this.searchOptions_.regDate_S || this.searchOptions_.regDate_E) {
			this.recentOneYearOnly = false;
		} else {
			this.applyRecentWindow();
		}

		this.init();
	},
	methods: {
		init() {
			// 상세검색 드롭다운 목록(매물종류·용도지역·부서·팀·담당자)은 팝업 컴포넌트가 직접 받는다.
			this.getItemList(1);
			this.getCountList();
		},
		getCountList() {
			this.$apiGET('/admin/api/detail/countList').then(data => {
				this.countList = data;
				this.countList.push('1');
				this.countList.pop();
			});
		},
		getItemList(pg) {
			this.$apiGET('/admin/api/total?' + 'page=' + (pg - 1) * this.itemSize + sellSearchParams(this.searchOptions)).then(data => {
				for (let i = 0; i < data.item.length; i++) {
					data.item[i].brifSt = false;
				}

				this.itemList = data.item;

				this.totalCount = data.pageInfo.totalCount;
				this.page = pg;
				this.pageData = this.$pageDataSetting(this.totalCount, this.itemSize, this.blockSize, this.page);
			});
		},
		// '최근 1년 등록만' 토글 — 매물등록일자(done_date_time) 기준 [오늘-1년, 오늘]로 한정.
		// 목록/카운트(SP_TOTAL_SEARCH/_COUNT)는 regDate 양끝이 있으면 mode 무관 필터한다.
		applyRecentWindow() {
			if (this.recentOneYearOnly) {
				const { s, e } = recentYearWindow();
				this.searchOptions_.regDate_S = s;
				this.searchOptions_.regDate_E = e;
				this.searchOptions.regDate_S = s;
				this.searchOptions.regDate_E = e;
			} else {
				this.searchOptions_.regDate_S = '';
				this.searchOptions_.regDate_E = '';
				this.searchOptions.regDate_S = '';
				this.searchOptions.regDate_E = '';
			}
		},
		onToggleRecentYear() {
			this.applyRecentWindow();
			this.btnSearch();
		},
		btnSearch() {
			this.searchOptions = normalizeSellSearch(this.searchOptions_);

			this.page = 1;
			this.getItemList(this.page);

			this.isDetailSearchPopupShow = false;
		},
		onDetailSearch(form) {
			this.searchOptions_ = form;
			this.btnSearch();
		},
		onDetailClose(form) {
			this.searchOptions_ = form;
			this.isDetailSearchPopupShow = false;
		},
		btnStOption() {
			if (this.searchOptions_.st) {
				this.searchOptions_.st_ = SELL_STATUS_ALL.slice();
			} else {
				this.searchOptions_.st_ = [];
			}
		},
		clearSearch() {
			this.searchOptions_ = defaultSellSearchOptions();
			this.applyRecentWindow(); // 초기화 후에도 토글 상태(최근 1년) 유지
		},
		// btnOnDetail(id) {
		// 	this.isDetailPopupShow = id;
		// },
		btnOnDetail(cid, idx, mode) {
			let w = window.screen.availWidth;
			let h = window.screen.availHeight;

			let attr = 'width=' + w + ', height=' + h + ', resizable=no, status=no';

			if (mode == 'total') {
				this.$apiGET('/admin/api/total/count?' + 'page=' + 1 + sellSearchParams(this.searchOptions)).then(data => {
					let idList = [];

					for (let i = 0; i < data.length; i++) {
						idList.push(data[i].building_uid);
					}

					const pageCnt = this.$store.state.pageCnt++;

					this.$store.dispatch('callSetPage', { idx: pageCnt, idList: idList });

					window.open(
						'/MapDetail/' +
							cid +
							'?pageIdx=' +
							pageCnt +
							'&idx=' +
							(idx + 1 + (this.page - 1) * this.itemSize) +
							'&totalCount=' +
							this.totalCount +
							'&mode=' +
							mode,
						'',
						attr,
					);
				});
			} else if (mode == 'count') {
				let idList = [];

				for (let i = 0; i < this.countList.length; i++) {
					idList.push(this.countList[i].building_uid);
				}

				window.open(
					'/MapDetail/' +
						cid +
						'?idx=' +
						(idx + 1) +
						'&totalCount=' +
						this.countList.length +
						'&idList=' +
						idList +
						'&mode=' +
						mode,
					'',
					attr,
				);
			}

			// console.log(openWin);
		},
		btnDelCount(id) {
			this.$apiPOST('/admin/api/detail/countList', { viewId: id }).then(data => {
				if (data) {
					this.getCountList();
				}
			});
		},
		async btnAddCart() {
			const bids = [];
			for (let i = 0; i < this.itemList.length; i++) {
				if (this.itemList[i].brifSt) bids.push(this.itemList[i].building_uid);
			}
			if (!bids.length) {
				alert('담을 물건을 1개 이상 선택하세요.');
				return;
			}
			const re = await this.$apiPOST('/partner/api/cart/add', { buildingType: 'sell', bids });
			if (re && re.st) alert('물건 ' + (re.added != null ? re.added : bids.length) + '건을 담았습니다.');
		},
		/**
		 * CM: 선택한 매물을 Weekly Report 에 담는다. 선택 방식은 '고객탭연결'(브리핑)과 같은
		 * brifSt 체크박스를 그대로 쓴다 — 직원이 이미 쓰는 흐름 위에 얹는 것이 목적이다.
		 * 넘어간 화면에서 새 Weekly 를 만들거나 **이미 있는 Weekly 에 더한다**(예전엔 누를 때마다
		 * 새 리포트만 생겨 한 리포트에 매물을 이어 담을 수 없었다. 2026-09-23 사용자 지적).
		 */
		btnOnWeekly() {
			const bids = [];
			for (let i = 0; i < this.itemList.length; i++) {
				if (this.itemList[i].brifSt) bids.push(this.itemList[i].building_uid);
			}
			if (!bids.length) {
				alert('Weekly 에 담을 물건을 1개 이상 선택하세요. (권장 4~6건)');
				return;
			}
			if (bids.length > 10) {
				alert('Weekly 는 최대 10건까지 담을 수 있습니다. (권장 4~6건)');
				return;
			}
			// 검색 결과를 잃지 않도록 새 창으로 연다('고객탭연결' 과 같은 방식).
			const w = window.screen.availWidth;
			const h = window.screen.availHeight;
			window.open('/ReportAdmin?bidList=' + bids.join(','), '', 'width=' + w + ', height=' + h + ', resizable=yes, status=no');
		},
		btnOnBriefing() {
			this.brifList = [];
			let st = false;

			for (let i = 0; i < this.itemList.length; i++) {
				if (this.itemList[i].brifSt) {
					this.brifList.push(this.itemList[i].building_uid);
					st = true;
				}
			}

			if (!st) {
				alert('브리핑 대기 물건을 1개 이상 선택하세요.');
				return;
			}

			let w = window.screen.availWidth;
			let h = window.screen.availHeight;

			let attr = 'width=' + w + ', height=' + h + ', resizable=no, status=no';

			window.open('/UserAdmin2?brifList=' + this.brifList, '', attr);
		},
		btnOnAddBrif() {
			for (let i = 0; i < this.itemList.length; i++) {
				if (this.brifSt) {
					this.itemList[i].brifSt = true;
				} else {
					this.itemList[i].brifSt = false;
				}
			}
		},
		callSMS() {
			if (!confirm('검색결과 기준 매도자들에게 매각 의사 문자를 보냅니다.')) {
				return;
			}

			this.$apiGET('/admin/api/sms?' + sellSearchParams(this.searchOptions)).then(re => {
				if (re.st) {
					alert('전송 완료');
				} else {
					alert(re.msg);
				}
			});
		},
	},
};
</script>

<style scoped>
/* 검색바(col-2 폭 950px 고정)에 '최근 1년 등록만' 토글이 추가되면서 한 줄을 넘쳐
   검색·필터 버튼이 박스 밖으로 잘렸음. 좌측 입력부를 [검색키워드] / [매물상태+체크박스]
   2행으로 분리하고, 우측 버튼은 항상 보이도록 고정한다. */
.search-top .left {
	flex-direction: column;
	align-items: flex-start;
	white-space: normal;
	row-gap: 10px;
}
.search-top .left .line {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	row-gap: 8px;
}
.search-top .left .line .input-label {
	flex-shrink: 0;
}
.search-top .right {
	flex-shrink: 0;
	align-self: center;
}
</style>
